import { Heading, Paragraph } from "@digdir/designsystemet-react";
import { ErrorPageProps } from "./types";
import { ErrorButton } from "./components/error-button";

export function ErrorPage({ heading, text }: ErrorPageProps) { 
    return (
        <div className="w-full max-w-[1470px] mx-auto flex items-center justify-center min-h-[50vh]">
            <div className="text-center px-4">
                <div className="max-w-4xl w-full">
                    <div className="mb-8">
                        {heading ? (
                            <Heading level={1} data-size="xl" className="!mb-4 text-brand">
                                {heading}
                            </Heading>
                        ) : (
                            <Heading level={1} data-size="xl" className="!mb-4 text-brand">
                                Beklager, vi finner ikke siden
                            </Heading>
                        )}
                        
                        {text && (
                            <Paragraph data-size="lg" className="!mb-0 text-gray-700 max-w-2xl mx-auto">
                                {text}
                            </Paragraph>
                        )}
                    </div>

                    <div className="flex justify-center">
                        <ErrorButton variant="secondary" onClick={() => window.location.href = '/'}>
                            Til forside
                        </ErrorButton>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ErrorPage;
